export default __webpack_public_path__ + "static/media/img-2-1200x1000.78ce5eca.jpg";